/**
 * Base of every view model: the error line of the view and the name of the template the view shows.
 *
 * A view model holds observables and actions and never touches the document. The markup in
 * public/index.html binds to it with data-bind attributes and switches between its states by the
 * template name, so the state of a view after a node call (form, review, result, error) is one
 * assignment to `template` and one to `error`.
 */

import ko from 'knockout';

export class ModelBase {
    /** The template the view renders now, through `template: { name: template }` in the markup. */
    readonly template = ko.observable('');
    /** Error text of the view; empty when there is none. Bound with `visible` and `text`. */
    readonly error = ko.observable('');

    displayErrors(err: unknown): void {
        this.error(err instanceof Error ? err.message : String(err));
    }

    hideErrors(): void {
        this.error('');
    }
}
